import Prismic from '@prismicio/client'

const apiEndpoint = "https://parrizo.cdn.prismic.io/api/v2";
const apiToken = "MC5ZWXNsYlJJQUFDMEFqSkND.77-9HO-_ve-_ve-_ve-_vSvvv71P77-9KgZ677-977-977-977-9M--_ve-_vXoSeWHvv73vv70WX--_vXfvv73vv70";

export const Client = Prismic.client(apiEndpoint, { accessToken:apiToken })

const apiEndpointForCareers = "https://parizzocareers.prismic.io/api/v2";
const apiTokenCareers = "MC5ZYTNfTnhNQUFDd0EyTlRH.77-9agzvv73vv70E77-9YVrvv73vv70A77-9F--_vQlMGUjvv73vv71uVu-_ve-_vTlWJ--_ve-_vQJr";

export const careersClient = Prismic.client(apiEndpointForCareers, { accessToken:apiTokenCareers })